<template>
<div class="examArrangement">
  <el-tabs v-model="activeName">
    <el-tab-pane label="未安排考生" name="notScheduled">
      <NotScheduled  v-if="activeName==='notScheduled'"/>
    </el-tab-pane>
    <el-tab-pane label="已安排考生" name="scheduled">
      <Scheduled v-if="activeName==='scheduled'" />
    </el-tab-pane>
  </el-tabs>
</div>
</template>

<script>
import NotScheduled from './notScheduled'
import Scheduled from './scheduled'

export default {
  name: "examInfo",
  components:{
    NotScheduled,
    Scheduled,
  },
  beforeCreate() {
    if(!this.$route.query.id){
      this.$router.go(-1);
      this.$message({ type: "warning", message: "id已过期,请重新查看!", duration: 1000 });
      return
    }
  },
  data(){
    return{
      activeName:'notScheduled',
    }
  },
  methods:{

  }
}
</script>
